export class DownloadStore {

  private platformId: number

  constructor() {
    this.platformId = 1;
  }

  public setPlatformId(id: number) {
    this.platformId = id;
  }
  public getPlatformId(): number {
    return this.platformId;
  }
}
